import { render } from "./ChooseAddress.vue?vue&type=template&id=7abba14a&scoped=true&ts=true"
import script from "./ChooseAddress.vue?vue&type=script&lang=ts"
export * from "./ChooseAddress.vue?vue&type=script&lang=ts"

import "./ChooseAddress.vue?vue&type=style&index=0&id=7abba14a&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7abba14a"]])

export default __exports__